import { Component, OnInit } from '@angular/core';
import { SmmService } from '../../../_services/smm.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
const moment = require('moment');
@Component({
  selector: 'app-dashboard6',
  templateUrl: './dashboard6.component.html',
  styleUrls: ['./dashboard6.component.scss']
})

export class Dashboard6Component implements OnInit {
  listPosts = [];
  spamFilter = false;
  isDashboard5 = true;
  singleSelectionProject = false;
  currentPage = 1;
  pageSize = 10;
  totalPostDetail = 0;
  currentFilter = null;
  currentPainPointId = null;
  painpointActive = true;

  dtOptions: DataTables.Settings = {};
  currentPost = null;

  listPostDetail = [];

  painPointName = {};

  modalRef: BsModalRef;
  constructor(private postService: SmmService, private modalService: BsModalService) {
    this.getPainPoint();
  }

  ngOnInit() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: true,
      searching: true,
      paging: true,
      language: {
        infoEmpty: 'Không tìm thấy dữ liệu',
        infoFiltered: '(trong _MAX_ )',
        info: 'Hiển thị _START_ - _END_ trên _TOTAL_',
        lengthMenu: 'Hiển thị _MENU_ ',
        search: 'Tìm kiếm',
        zeroRecords: 'Không có dữ liệu !',
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>',
        }
      },
      columnDefs: [
        { 'targets': [0], 'searchable': true }
      ]
    };

  }

  getPainPoint() {
    this.postService.getPainPoint().subscribe(res => {
      if (res.success) {
        res.data.forEach(painPointItem => {
          this.painPointName[painPointItem._id] = painPointItem.name;
        });
        console.log(this.painPointName)
      }
    })
  }

  showModalDetail(paintPointId, count, modalRef) {
    this.currentPage = 1;
    this.totalPostDetail = count;
    this.currentPainPointId = paintPointId;
    let filter = {
      gte: this.currentFilter.gte,
      lte: this.currentFilter.lte,
      size: this.pageSize,
      paintPointId: paintPointId,
      projectsSelected: this.currentFilter.projectsSelected,
      from: this.currentPage -1
    };
    this.listPostDetail = [];
    this.postService.getRecentPost({ filter: filter }).subscribe(res => {
      if (res.success) {
        this.listPostDetail = res.data.hits.hits;

        this.modalRef = this.modalService.show(modalRef, {
          keyboard: false,
          backdrop: 'static',    
          class: 'custom-modal'
        });
      }
    });
  }
  pageChange(number) {
    this.listPostDetail = [];
    this.currentPage = number;
    let filter = {
      gte: this.currentFilter.gte,
      lte: this.currentFilter.lte,
      size: this.pageSize,
      paintPointId: this.currentPainPointId,
      projectsSelected: this.currentFilter.projectsSelected,
      from: (this.currentPage - 1) *  this.pageSize
    };
    this.postService.getRecentPost({ filter: filter }).subscribe(res => {
      if (res.success) {
        this.listPostDetail = res.data.hits.hits;
      }
    });
 }

  onFilterChange(filter) {
    this.currentFilter = filter;
    this.listPosts = [];
    this.currentPage = 0;
    let newsFilter = {
      gte: filter.gte,
      lte: filter.lte,
      projectsSelected: this.currentFilter.projectsSelected
    };
    this.getDataFromServer(newsFilter);
  }



  getDataFromServer(filter) {
    this.postService.groupByPainPoint({ filter: filter }).subscribe(res => {
      if (res.success) {
        this.listPosts = res.data.aggregations.painPoint.buckets
      }
    });
  }

  getHostname(url) {
    return new URL(url).hostname;
  }
  getPostFacebookUrl(docId) {
    return `https://facebook.com/${docId}`
  }

}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard6/dashboard6.component.ts